module.exports = __webpack_public_path__ + "static/img/xinpian1.d20fba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/xinpian1.png
// module id = iy1a
// module chunks = 1